import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Milestone } from 'lucide-react';
import { Task } from '@/core/state-shape';

// Placeholder for Timeline component
export const TimelineViewer = ({ timeline }: { timeline: Task['timeline'] | undefined }) => {
    if (!timeline || timeline.length === 0) {
        return <p>No timeline events available for this task.</p>;
    }
    return (
        <Card>
            <CardHeader><CardTitle>Activity</CardTitle></CardHeader>
            <CardContent>
                <ul className="space-y-4">
                    {timeline.map((event, index) => (
                        <li key={index} className="flex gap-4">
                            <div className="flex flex-col items-center">
                                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground">
                                    <Milestone className="h-4 w-4" />
                                </span>
                                {index < timeline.length - 1 && <div className="h-full w-px bg-border" />}
                            </div>
                            <div>
                                <p className="font-semibold">{event.summary}</p>
                                <time className="text-xs text-muted-foreground">{new Date(event.ts).toLocaleString()}</time>
                            </div>
                        </li>
                    ))}
                </ul>
            </CardContent>
        </Card>
    );
}